import React, {Component} from "react";
import {getCashBackRequestURL, getHeader} from "../../config";
import axios from "axios";
import {showToast} from "../../helpers/magic";
import {withTranslate} from "react-redux-multilingual";
import HistoryHeader from "./HistoryHeader";
import HistoryOptions from "./HistoryOptions";
import {statuses} from "./constants";





class HistoryCard extends Component {
    state = {
        cashBackBtnStatus: true,
    };

    requestCashBack = (reservation_id) => {
        axios.post(getCashBackRequestURL, {reservation_id: reservation_id}, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                showToast(this.props.translate("cash_back_requested_successfully"), "green");
                this.setState({
                    cashBackBtnStatus: false,
                })
            } else {
                showToast(this.props.translate("something_wrong"), "red")
            }
        }).catch(err => {
        })
    };


    render() {
        const {pastReservation, translate, changePopUpStatus} = this.props;

        return (
            <div id="accordion" className="history-card shadow-4d relative">

                <p hidden={pastReservation.status !== statuses.CANCELED}
                   className="canceled-res capitalized">{translate("canceled")}</p>

                <p hidden={pastReservation.status !== statuses.MISSED}
                   className="canceled-res capitalized">{translate("missed")}</p>
                <div className="visit-day">
                    <p>{pastReservation.full_day}</p>
                </div>

                <HistoryHeader pastReservation={pastReservation}/>

                <HistoryOptions pastReservation={pastReservation} changePopUpStatus={changePopUpStatus}/>

            </div>
        )
    }
}

export default withTranslate(HistoryCard);
